import { type FC, type PropsWithChildren } from 'react'
import styled from 'styled-components'

import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const ContentWrapper = styled.div<{ $hasTakeover: boolean }>(
  ({ theme, $hasTakeover }) => `
  position: relative;
  transition: all 0.3s ease;

  ${
    $hasTakeover
      ? `
    ${MEDIA_QUERIES(theme).large} {
      z-index: 1;
      pointer-events: none;
    }
  `
      : ''
  }
`
)

export const TakeoverContentWrapper: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(GPT_COMPONENT_ID.TAKEOVER)

  return <ContentWrapper $hasTakeover={hasTakeover}>{children}</ContentWrapper>
}
